<mat-selection-list #hotel [multiple]="false" class="m-3" style="max-width: 360px !important;" data-toggle="modal" data-target="#exampleModal">
  <mat-list-option *ngFor="let hotel of hotelList" [value]="hotel.hotelname" style="border-bottom: 1px solid lightgray;">
    {{hotel.hotelname}} - {{hotel.address}}
  </mat-list-option>
</mat-selection-list>
